import {gql} from '@apollo/client';

export const Name = gql`
    fragment Name on Name {
        firstName
        fullName
        lastName
        middleName
    }
`;
